import { gql } from "@apollo/client";

export const GET_ROLE_PERMISSIONS = gql`
  query RolePermissions {
    rolePermissions {
      count
      items {
        roleId
        roleName
        roleKey
        roleDescription
        roleIsActive
        allowedUserKinds
        createdAt
        updatedAt
        roleFeatures {
          featureId
          featureName
          featureKey
          featureDescription
          featureIsActive
          featureIsMainMenu
          featureDisplayName
          featurePermissions {
            id
            name
            isActive
            createdAt
            createdBy
            deletedAt
            deletedBy
            updatedAt
            updatedBy
            description
            permissionKey
            allowedBotTypes
            allowedUserKinds
            allowedAdminTypes
          }
        }
      }
    }
  }
`;
